module.exports = __webpack_public_path__ + "img/logo-tmdb.08392f18.svg";